<template>
  <v-form autocomplete="off">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ editing ? 'Reject Defect For' : 'Rejected Defect For' }}
          <router-link
            class="accent--text text--lighten-1"
            :to="{name:'unit', params: { unitId: defect.unitId }}"
          >{{ defect.unitNumber }}
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="header" v-if="!defect.isStale"></slot>
      </v-toolbar>

      <v-card-text>
        <!-- Stale Data Warning -->
        <stale-data-alert
          :is-stale="defect.isStale || false"
          message="This defect has been updated by another user. Please refresh to see updated data."
          @refresh="refreshPage"
        ></stale-data-alert>

        <v-container v-if="!defect.isStale">
          <v-layout wrap class="mx-4">
            <v-flex xs12 class="pt-3">
              <v-chip>{{ defect.ednNumber }}</v-chip>
            </v-flex>
            <v-flex
              class="py-3 caption"
              xs12
            >{{ defect.lineNumber ? defect.lineNumber + ': ' : '' }} {{ defect.description }}
            </v-flex>
            <v-container>
              <v-flex xs12>
                <v-textarea
                  v-model="defect.rejectedReason"
                  label="Reason this defect is rejected"
                  v-validate="'required'"
                  name="rejected reason"
                  :error-messages="errors.first('rejected reason')"
                  required
                  :disabled="disabled"
                ></v-textarea>
              </v-flex>
            </v-container>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!defect.isStale">
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
        <v-btn v-if="editing" color="red white--text" :disabled="disableSubmit" @click="submit">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
  import DefectsClient from '@/components/DefectNotices/DefectNoticesClient.vue';
  import FormValidation from '@/components/FormValidation.vue';
  import moment from 'moment/moment';
  import StaleDataAlert from '@/components/DefectNotices/StaleDataAlert.vue';

  export default {
    mixins: [DefectsClient, FormValidation],
    components: { StaleDataAlert },
    props: {
      defect: {
        required: true
      }
    },
    data() {
      return {
        editing: false,
        submitted: false
      };
    },
    computed: {
      disableSubmit() {
        return Object.keys(this.fields).some(key => this.fields[key].validated && this.fields[key].invalid);
      },
      disabled() {
        return !this.editing;
      }
    },
    methods: {
      init(editing) {
        this.editing = editing;
        this.$validator.reset();
      },
      submitForm() {
        this.submitted = true;
        this.$emit('reject', { id: this.defect.id, model: { defectId: this.defect.id, rejectedDate: moment(), rejectedReason: this.defect.rejectedReason } });
        setTimeout(() => (this.submitted = false), 1000);
      },
      async refreshPage() {
        try {
          // Emit an event to the parent to refresh the defect page
          this.$emit('refresh-page');

          // Close the modal
          this.$emit('close-modal');
        } catch (error) {
          this.$toast.error('Failed to refresh page');
        }
      }
    }
  };
</script>
<style scoped>
  ::v-deep .v-toolbar__title {
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
  }
</style>
